import React from "react";
import { useAuth } from "./useAuth";
import { Navigate, Outlet, useLocation } from "react-router-dom";
export default function ProtectedRoute({ children }) {
    const { isAuthenticated, inProgress } = useAuth();
    const location = useLocation();
    // During MSAL startup/redirect processing, wait instead of redirecting
    if (!isAuthenticated && inProgress && inProgress !== "none") {
        return (React.createElement("div", { style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "200px",
            } },
            React.createElement("span", null, "Loading\u2026")));
    }
    if (!isAuthenticated) {
        const redirectTarget = location.pathname + location.search + location.hash;
        if (typeof sessionStorage !== "undefined") {
            try {
                sessionStorage.setItem("postLoginRedirect", redirectTarget);
            }
            catch (_a) {
                // ignore: best-effort
            }
        }
        return React.createElement(Navigate, { to: "/login", replace: true });
    }
    // Support both wrapper usage (<ProtectedRoute>{children}</ProtectedRoute>)
    // and route-guard usage (<Route element={<ProtectedRoute/>}> ... )
    if (children)
        return React.createElement(React.Fragment, null, children);
    return React.createElement(Outlet, null);
}
